import { app } from "modular-openscriptjs";
import { STRINGS } from "../declarations";

/**
 * The NavItems
 */
export class NavItem {
	icon;
	text;
	route;
	onclick = "default";
	// Shown to everyone by default - guests included. Account-only
	// destinations ask for sign-in when tapped (middleware.auth /
	// requireAuth), not by hiding the item. Pass a condition only for
	// real restrictions such as a staff permission.
	condition = () => true;
	children = [];
	pageName = "no-page";
	appHook = null;

	/**
	 *
	 * @param {string|HTMLElement} text
	 * @param {string} onclick
	 * @param {string} route
	 * @param {Function|null} icon
	 * @param {Function} condition - returns true or false. Used
	 * to determine whether the nav should be shown. Defaults to always
	 * shown.
	 */
	constructor(
		text,
		onclick = STRINGS.DEFAULT,
		route = null,
		icon = null,
		condition = null,
		children = [],
		pageName = null,
		appHook = null,
	) {
		this.text = text;
		this.route = route;
		this.icon = icon;
		this.onclick = onclick;
		this.condition = condition ?? this.condition;
		this.children = children;
		this.pageName = pageName ?? this.text;
		this.appHook = appHook;

		if (this.onclick == STRINGS.DEFAULT && this.route != null) {
			this.onclick = `app("router").to('${this.route}')`;
		}
	}

	/**
	 * Creates a new nav
	 * @param {Object<>}
	 */
	static new(
		config = {
			text: "",
			route: null,
			onclick: STRINGS.DEFAULT,
			icon: null,
			condition: () => true,
			children: [],
			pageName: null,
			appHook: null,
		},
	) {
		return new NavItem(
			config.text,
			config.onclick,
			config.route,
			config.icon,
			config.condition,
			config.children,
			config.pageName,
			config.appHook
		);
	}

	static page(pageName) {
		app("pc").activePage.value = pageName;
	}
}
